import { registerTheme, type Theme } from '../types';
import { defaultTokens } from './tokens';
import { ringFragment } from './ring';
import { bandFragment } from './band';
import { monthFragment } from './month';
import { dayFragment } from './day';
import { todayFragment } from './today';
import { ringMarkFragment } from './mark';
import { leaderFragment } from './leader';
import { floatFragment } from './float';
import { clusterFragment } from './cluster';

export const defaultTheme: Theme = registerTheme({
  name: 'default',
  tokens: defaultTokens,
  fragments: {
    ring: ringFragment,
    band: bandFragment,
    month: monthFragment,
    day: dayFragment,
    ringMark: ringMarkFragment,
    leader: leaderFragment,
    float: floatFragment,
    cluster: clusterFragment,
    today: todayFragment,
  },
});

export { defaultTokens } from './tokens';
export { M as defaultMetrics, FLOAT as defaultFloatMetrics } from './metrics';
